import React from 'react';
import {observer} from 'mobx-react';
import {CmsBannerComponent} from '../cms-banner/cms-banner.component';
import {DailyDealComponent} from "../daily-deal/daily-deal.component";
import {RoutedComponent} from '../base-components/routed-component/routed.component';
import {LayoutWrapperBox} from "../../basic-components/layout-wrapper/layout-wrapper.box";
import {MOVE_TOP} from "../../themes/css-global-classes";
import classNames from "classnames";
import {HomePageHeaderArenasComponent} from "../home-page-header-arenas/home-page-header-arenas.component";
import {HomepageTopBannerBackgroundBox} from "./boxes/home-page-top-banner-background.box";
import {HomepageTopBannerDividerBox} from './boxes/home-page-top-banner-divider-line';
import {CyClass} from '../../../common/cy-classes';
import {LinkToOfferComponent} from "../link-to-offer/link-to-offer.component";
import {ArenaGamesListsComponent} from "../arena-games-lists/arena-games-lists.component";
import {HOME_PAGE_ARENA} from "../../services/arenas/arena-consts";
import {FreeToPlayAnimatedIconComponent} from "../free-to-play-animated-icon/free-to-play-animated-icon.component";
import {BannerComponent} from "../banner/banner.component";

export const HomePageComponent = observer(class HomePageComponent extends RoutedComponent<{}> {

  private _renderTopBanner() {
      const topBannerProps = this.services.homepage.getTopBannerProps();

      return (
          <>
              <HomepageTopBannerBackgroundBox key="HOME_PAGE_TOP_BANNER_BACKGROUND" minHeight={topBannerProps.minHeight} className={CyClass('cy-homepage-top-banner-background')}/>
              <BannerComponent key={'HOME_PAGE_TOP_BANNER'} {...topBannerProps}/>
              {this.services.homepage.headerArenasStyleIsSmallTiles && !this.services.homepage.useAdminBanner? <HomepageTopBannerDividerBox key="HOME_PAGE_TOP_BANNER_DIVIDER" className={CyClass('cy-homepage-top-banner-divider')}/> : null}
          </>
      );
  }

  private _renderHomePageArenaHeaders() {
    if(this.services.device.hybrid.isEmbedded) {
      return null;
    }

    return <HomePageHeaderArenasComponent key={'HOME_PAGE_ARENAS_HEADERS'} />;
  }

  private _renderSeoBanner() {
    if(this.services.device.hybrid.isEmbedded) {
      return null;
    }
    let bannerConfig = this.services.configuration.data.homePage.seoSection;
    if(!bannerConfig.display) {
      return null;
    }
    return (
      <CmsBannerComponent key={'HOME_PAGE_SEO_BANNER'}
                          className={'seo-section'}
                          showPlaceholder={false}
                          componentID={bannerConfig.componentID}
                          templateID={bannerConfig.templateID}
                          fallbackComponent={bannerConfig.fallbackComponent}/>
    );
  }

  private _renderLinkToOffer() {
    return (
      <>
        <LinkToOfferComponent key="HOME_PAGE_LINK_TO_OFFER"
                              linkToOfferConfig={this.services.configuration.data.homePage.linkToOffer}/>
        <FreeToPlayAnimatedIconComponent/>
      </>
    );
  }

 render() {
      const className = classNames('cy-layout-wrapper-homepage', {
        [MOVE_TOP]: this.services.homepage.headerArenasStyleIsBigTiles
    });

    return (
      <>
        {this._renderTopBanner()}
        <LayoutWrapperBox className={className} key="HOME_PAGE_LAYOUT_WRAPPER">
            {this._renderHomePageArenaHeaders()}
            <ArenaGamesListsComponent key={"HOME_PAGE_LISTS"} arenaName={HOME_PAGE_ARENA}/>
            <DailyDealComponent />
        </LayoutWrapperBox>
        {this._renderSeoBanner()}
        {this._renderLinkToOffer()}
      </>
    );
  }
});